require('/opt/odin/app/frontend/components/directed_sheet_news/index.module.scss');module.exports = "../../app/cells/components/directed_sheet_news/show.erb";